export const INFO = 'info';
export const ERROR = 'error';
export const SUCCESS = 'success';
export const WARNING = 'warning';
